import React from 'react';
import { ComponentsProps, ComponentsOverrides, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/system/createTheme';
import { RightIcon } from '../../components';

export const MuiBreadcrumbs: {
    defaultProps?: ComponentsProps['MuiBreadcrumbs'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiBreadcrumbs'];
    variants?: ComponentsVariants['MuiBreadcrumbs'];
} = {
    defaultProps: {
        separator: <RightIcon fontSize="small" color="disabled" />,
        itemsAfterCollapse: 2,
        itemsBeforeCollapse: 1,
        maxItems: 5,
    },
};
